import { z } from 'zod';
import { IsoTimestamp, SchoolId } from './common.js';
/**
 * Grade Level reference data.
 *
 * A Grade Level is a shared reference used by Classroom, Quiz, Question Bank,
 * Class Membership, Teaching Assignment, and Reports. CBT supports both
 * standalone mode (admin manages locally) and integrated mode (synced from
 * AIMSIS with an externalGradeLevelId for matching).
 *
 * Firestore path: schools/{schoolId}/gradeLevels/{gradeLevelId}
 */
export const GradeLevelSource = z.enum(['local', 'integrated']);
export const GradeLevelStatus = z.enum(['active', 'inactive', 'archived']);
/**
 * Longest Grade Level name the master accepts. The Quiz Editor offers these
 * names as selectable labels, and a quiz can select several at once, so the
 * quiz's `gradeLevel` field is sized from this rather than from a guess.
 */
export const GRADE_LEVEL_NAME_MAX = 200;
export const GradeLevel = z.object({
    id: z.string().min(1).max(64),
    schoolId: SchoolId,
    name: z.string().min(1).max(GRADE_LEVEL_NAME_MAX),
    code: z.string().min(1).max(32),
    displayOrder: z.number().int().nonnegative().default(0),
    status: GradeLevelStatus.default('active'),
    source: GradeLevelSource.default('local'),
    externalGradeLevelId: z.string().min(1).max(128).nullable().optional(),
    createdAt: IsoTimestamp,
    updatedAt: IsoTimestamp,
});
export const CreateGradeLevelRequest = z.object({
    name: z.string().min(1).max(GRADE_LEVEL_NAME_MAX),
    code: z.string().min(1).max(32),
    displayOrder: z.number().int().nonnegative().optional(),
    status: GradeLevelStatus.optional(),
});
export const UpdateGradeLevelRequest = z.object({
    name: z.string().min(1).max(GRADE_LEVEL_NAME_MAX).optional(),
    code: z.string().min(1).max(32).optional(),
    displayOrder: z.number().int().nonnegative().optional(),
    status: GradeLevelStatus.optional(),
});
//# sourceMappingURL=grade-level.js.map